import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Chart, registerables } from "chart.js";

@Component({
  selector: "app-example-dialog",
  templateUrl: "chart-dialog.component.html",
})
export class ChartDialogComponent {
  myChart: any;

  constructor(
    public dialogRef: MatDialogRef<ChartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("data:", this.data);
    Chart.register(...registerables);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    console.log("data1:", this.data);
    this.createChart(this.data["x-axis"], this.data["y-axis"]);
  }

  createChart(labels, data) {
    this.myChart = new Chart("canvas-line", {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            // label: "number of applications related to",
            data: data,
            backgroundColor: "rgba(54, 162, 235, 0.2",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            title: { display: true, text: "Response time in ms" },
            // beginAtZero: false,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  }
}
